
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ACADEMIC_YEAR_STATUS, YEAR_LIST, PROGRAM_OPTION, PROGRAM_TERMS } from 'src/app/dummy/app';
import { ConvertService } from 'src/app/services/convert.service';
import { DataService } from 'src/app/services/data.service';
import { checkExistOnEditStore } from 'src/app/services/fire-validators.service';
import { MappingService, userObj, schoolObj } from 'src/app/services/mapping.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { TrainingStore } from 'src/app/stores/training/training.store';

@Component({
  selector: 'app-edit-year',
  templateUrl: './edit-year.component.html',
  styleUrls: ['./edit-year.component.scss']
})
export class EditYearComponent implements OnInit {
  // @ViewChild("focusInput") inputEl: ElementRef;
  form: FormGroup;
  name: AbstractControl;
  startDate: AbstractControl;
  endDate: AbstractControl;
  yearStatus: AbstractControl;
  note: AbstractControl;
  memo: AbstractControl;
  startEnroll: AbstractControl;
  endEnroll: AbstractControl;
  endPayment: AbstractControl;
  dropClass: AbstractControl;
  programOption: AbstractControl
  program_term: AbstractControl;
  organization: AbstractControl;

  academic_year: AbstractControl;
  end_year_date: AbstractControl

  yearStatusList = ACADEMIC_YEAR_STATUS;
  academicYearList = YEAR_LIST;
  programOptionList = PROGRAM_OPTION
  programTermList = PROGRAM_TERMS;
  organizationList: any = []


  constructor(
    public dialogRef: MatDialogRef<EditYearComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public env: AuthStore,
    private snackBar: MatSnackBar,
    private afs: AngularFirestore,
    private ds: DataService,
    public dialog: MatDialog,
    public store: TrainingStore,

  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required]), checkExistOnEditStore(this.afs, this.data.organizationKey, "academic_year", "name", this.data.name)],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      yearStatus: [null, Validators.required],
      programOption: [null, Validators.required],
      note: [null,],
      memo: [null,],
      startEnroll: [null],
      endEnroll: [null,],
      dropClass: [null,],
      endPayment: [ConvertService.addDays(15), Validators.required],
      academic_year: [null, Validators.required],
      end_year_date: [ConvertService.addMonth(12), Validators.required],
      program_term: [PROGRAM_TERMS[0], [Validators.required]],
      organization: [this.organizationList[0], Validators.required],
    })

    this.program_term = this.form.controls["program_term"];
    this.programOption = this.form.controls['programOption'];
    this.name = this.form.controls['name'];
    this.startDate = this.form.controls['startDate'];
    this.endDate = this.form.controls['endDate'];
    this.yearStatus = this.form.controls['yearStatus'];
    this.note = this.form.controls['note'];
    this.memo = this.form.controls['memo'];
    this.startEnroll = this.form.controls['startEnroll'];
    this.endEnroll = this.form.controls['endEnroll'];
    this.endPayment = this.form.controls['endPayment'];
    this.dropClass = this.form.controls['dropClass'];
    this.academic_year = this.form.controls['academic_year'];
    this.end_year_date = this.form.controls['end_year_date'];
  }

  itemDoc = null
  async ngOnInit() {
    this.buildForm();
    this.organizationList = await this.store.fetchOrganization();
    const { organization, name, startDate, endDate, yearStatus, note, memo, startEnroll, endEnroll,
      endPayment, dropClass, termType, academic_year, end_year_date, program_term } = this.data;
    this.form.patchValue({
      name: name,
      yearStatus: yearStatus,
      note: note,
      memo: memo,
      startDate: startDate ? startDate.toDate() : null,
      endDate: endDate ? endDate.toDate() : null,
      endPayment: endPayment ? endPayment.toDate() : null,

      startEnroll: startEnroll ? startEnroll.toDate() : null,
      endEnroll: endEnroll ? endEnroll.toDate() : null,
      dropClass: dropClass ? dropClass.toDate() : null,

      programOption: termType,
      end_year_date: end_year_date ? end_year_date.toDate() : null,
      academic_year,
      organization: organization,
      program_term: program_term ? program_term : null
    })

    // if (termType.key === 2) this.program_term.enable()
    // else this.program_term.disable()

    // this.store.fetchAcademicYearDoc(this.data, (doc) => {
    //   this.itemDoc = doc
    // })
  }

  _selectionChange(event) {
    const { value } = event;
    if (value && value.key === 2) this.program_term.enable()
    else this.program_term.disable()
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  // addNewLine(item?: any) {
  //   const dialogRef = this.dialog.open(AddYearStartEndComponent, {
  //     data: { ITEM: item, TERM: this.itemDoc },
  //     panelClass: 'register-test-overlay-panel',
  //     width: '600px',
  //     height: '100vh',
  //     disableClose: true,
  //     role: 'dialog'
  //   });
  //   dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
  //   dialogRef.afterClosed().subscribe(result => { });
  // }

  // delete(item) {
  //   const { programTermItems } = this.itemDoc;
  //   const programTermItemsData = programTermItems.filter(m => m.key !== item.key);

  //   this.store.updateAcademicYear("academic_year", this.itemDoc, MappingService.orderBy(programTermItemsData, "key"), (success, error) => {
  //     if (success) {
  //       this.snackBar.open('Academic Year has been updated.', 'done', { duration: 2500 });
  //     }
  //     else {
  //       alert(error)
  //     }
  //   })
  // }

  create(f: any) {
    if (this.form.valid) {
      this.form.disable();
      const { organization, name, startDate, endDate, yearStatus, note, memo, startEnroll, endEnroll, endPayment, dropClass, programOption, academic_year, end_year_date, program_term } = f;

      const item = {
        // programTermItems: programTermItems,
        key: this.data.key,
        name: name,
        note: note,
        memo: memo,
        startDate: startDate,
        startDateKey: ConvertService.toDateKey(startDate),
        endDate: endDate,
        endDateKey: ConvertService.toDateKey(endDate),

        startEnroll: startEnroll,
        startEnrollKey: ConvertService.toDateKey(startEnroll),
        endEnroll: endEnroll,
        endEnrollKey: ConvertService.toDateKey(endEnroll),
        dropClass: dropClass,
        dropClassKey: ConvertService.toDateKey(dropClass),

        endPayment: endPayment,
        endPaymentKey: ConvertService.toDateKey(endPayment),

        academic_year,
        end_year_date,
        end_year_date_key: ConvertService.toDateKey(end_year_date),
        termType: programOption,
        program_term: program_term ? program_term : null,

        update_date: new Date(),
        update_by: userObj(this.env.user),
        schoolKey: organization.key,
        organization: schoolObj(organization),
        organizationKey: organization.key,
      }

      this.store.updateSub("academic_year", item, (success, error) => {
        if (success) {
          this.dialogRef.close();
          this.snackBar.open('Academic Year has been updated.', 'done', { duration: 2500 });
          this.form.enable();
          this.form.reset();
          // this.inputEl.nativeElement.focus();
        }
        else {
          alert(error)
        }
      })
    }
  }

}
